/**
 * Helpers for FEFO suggestion / override checks shared by OMS outbound UIs.
 */

export function fefoSuggestedBatchId(result: unknown): string | undefined {
  const payload = result as {
    fefoSuggested?: Array<{ batchId?: string }>;
    allocations?: Array<{ batchId?: string }>;
  } | null;
  return (
    payload?.fefoSuggested?.[0]?.batchId ??
    payload?.allocations?.[0]?.batchId ??
    undefined
  );
}

export function isLotRequiredFromResolve(result: unknown): boolean {
  const payload = result as { lotRequired?: boolean } | null;
  return Boolean(payload?.lotRequired);
}

/**
 * True when the chosen lot is not FEFO (or no FEFO suggestion exists) and the
 * operator has not yet provided an override reason.
 */
export function needsFefoOverrideReason(params: {
  lotRequired?: boolean;
  chosenLot?: string | null;
  suggestedLot?: string | null;
  overrideReason?: string | null;
}): boolean {
  if (!params.lotRequired) {
    return false;
  }
  const chosen = params.chosenLot?.trim();
  if (!chosen) {
    return false;
  }
  if (params.overrideReason?.trim()) {
    return false;
  }
  const suggested = params.suggestedLot?.trim();
  return !suggested || suggested !== chosen;
}
